import { COLORS } from '@btime/constants'
import React from 'react'

import { getLocalStorageItem } from '../../../utils/helpers/localStorage'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import SideMenuTemplate from '../../../components/templates/v2/SideMenuTemplate'
import { useNewFeature } from '../../../utils/contexts/NewFeature'

const ServiceOrdersRootPage = () => {
  const navigate = useNavigation()
  const { isActive } = useNewFeature('PROCESSES')

  React.useEffect(() => {
    if (isActive) {
      const lastViewMode = getLocalStorageItem('LAST_PROCESS_VIEW_MODE') || 'kanban'
      const lastProcessId = getLocalStorageItem('LAST_PROCESS_ID')
      return navigate(`/processes/${lastViewMode}/${lastProcessId}`)
    }

    const urlSufix = getLocalStorageItem('SERVICE_ORDERS_LAST_SCREEN') || 'list'
    navigate(`/service-orders/${urlSufix}`)
  }, [])

  return <SideMenuTemplate bgColor={COLORS.white}></SideMenuTemplate>
}

export default ServiceOrdersRootPage
